import { SidePanel } from '@components/app/side-panel';
import { useContactQuery } from '@queries/crm/contacts';
import { useIsTeamAdmin } from '@queries/team/teams';
import { Show } from 'solid-js';
import { ContactDiscussionSection } from './ContactDiscussionSection';
import { ContactEmailsSection } from './ContactEmailsSection';
import { ContactHeader } from './ContactHeader';
import { ContactMetadataSection } from './ContactMetadataSection';
import { ContactSharingSection } from './ContactSharingSection';

/**
 * Root of the contact detail view. Owns the contact query and pushes the
 * resolved entity down to presentational children. Layout mirrors the
 * company block: middle content constrained to a centered column, with
 * additional info in the right-hand SidePanel.
 */
export function Contact(props: {
  contactId: string;
  headerToggle?: boolean;
  onOpenCompany?: (companyId: string) => boolean;
}) {
  const contactQuery = useContactQuery(() => props.contactId);
  const contact = () => contactQuery.data;
  const isTeamAdmin = useIsTeamAdmin();

  return (
    <SidePanel.Layout headerToggle={props.headerToggle}>
      <div class="flex h-full flex-col overflow-y-auto scrollbar-hidden">
        <div class="mx-auto flex w-full max-w-3xl min-w-0 grow flex-col gap-6 px-6 pt-12 pb-12">
          <ContactHeader contact={contact()} />
          <ContactDiscussionSection contactId={props.contactId} />
          <ContactEmailsSection contact={contact()} />
        </div>
      </div>

      <SidePanel.Section
        id="contact-details"
        title="Details"
        order={10}
        defaultOpen
      >
        <ContactMetadataSection
          contact={contact()}
          onOpenCompany={props.onOpenCompany}
        />
      </SidePanel.Section>
      {/* Sharing is admin-only; hide the whole section for non-admins
          rather than rendering it empty. */}
      <Show when={isTeamAdmin()}>
        <SidePanel.Section id="contact-sharing" title="Sharing" order={25}>
          <ContactSharingSection contact={contact()} />
        </SidePanel.Section>
      </Show>
      {/* TODO: add a References section (inbound channel messages + documents)
          once the references backend supports the crm_contact entity type. */}
    </SidePanel.Layout>
  );
}
